import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

interface EmailInputProps {
    email: string;
    onSetEmail: (email: string) => void;
    onSetIsEmailValid: (isEmailValid: boolean) => void;
}

export const EmailInput: React.FunctionComponent<EmailInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const requiredEmailError = 'Email is a required field.';
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    useEffect(() => {
        props.onSetIsEmailValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        props.onSetEmail((event.target as HTMLInputElement).value);
        validateEmail();
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateEmail();
    }

    const validateEmail = () => {
        let errorsTemp: string[] = [];
        if (props.email === '') {
            errorsTemp.push(requiredEmailError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        setIsSubmitted(true);
        validateEmail();
    }

    return <div>
        <Input isValid={isValid} type='text' required={true} value={props.email} onChange={onChange}
               onKeyUp={onKeyUp} onBlur={onBlur}/>
        {isSubmitted && errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
